import { render, staticRenderFns } from "./SubscriptionUserwiseDetailsReport.vue?vue&type=template&id=4ef06195&"
import script from "./SubscriptionUserwiseDetailsReport.vue?vue&type=script&lang=js&"
export * from "./SubscriptionUserwiseDetailsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports